import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { Translate, SafeAnchor } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  link: {
    marginBottom: theme.spacing(1)
  }
}));

export const XmlSitemaps = ({ criterium }) => {
  const classes = useStyles();
  const { data, url } = criterium;
  const { variant } = useReviewContext();

  const hasNewData = data.sitemaps && data.sitemaps.length > 0;
  let content;
  if (hasNewData) {
    content = (
      <>
        {data.notInRobots && (variant === 'nocrit' ? <CriteriumSkeleton width='50%' /> : <Translate content='sitemap_found_at' />)}
        {data.sitemaps.map(url => (
          <div key={url} className={classes.link}>
            {variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank'>{url}</SafeAnchor>}
          </div>
        ))}
        {data.notInRobots && (variant === 'nocrit' ? <CriteriumSkeleton width='50%' /> : <Translate content='sitemap_add_to_robots' />)}
      </>
    );
  } else {
    const hasOldData = data.length > 0;
    if (hasOldData) {
      content = data
        .filter(x => !!x)
        .map(url => (
          <div key={url} className={classes.link}>
            {variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank'>{url}</SafeAnchor>}
          </div>
        ));
    } else {
      content = variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='sitemap_not_found' />;
    }
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url }}
    >
      {content}
    </Criterium>
  );
};

XmlSitemaps.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      sitemaps: PropTypes.array,
      notInRobots: PropTypes.bool
    })
  })
};

export default React.memo(XmlSitemaps);
